import { makeApiCall } from '../../redux/actions/common/common-action';
import { splitFullAddress } from '../../screens/beneficiary-info/address-block/hooks';
import { API_URL_V3 } from '../../utils/config';

export const handleFetchPlaceDetails: any = async (countryCode: string, placeId: string) => {
  try {
    const response = await makeApiCall({
      url: `${API_URL_V3}/location/details?placeId=${placeId}&countryCode=${countryCode}`,
      method: 'get',
      withCredentials: true
    });

    const data = response?.data?.data?.data?.data || {};
    const result = { ...data, ...splitFullAddress(data.fullAddress || '') };
    return result;
  } catch (error) {
    //eslint-disable-next-line
    console.log(error);
  }
};

type retrievedPlacesType = {
  place_id: string;
  description: string;
};

export const handleFetchPlaceId: any = async (countryCode: string, keyword: string) => {
  if (keyword.length < 3) return;
  try {
    const response = await makeApiCall({
      url: `${API_URL_V3}/location/autocomplete?keyword=${keyword}&countryCode=${countryCode}`,
      method: 'get',
      withCredentials: true
    });
    let retrievedPlaces = response?.data?.data?.data?.data;

    if (retrievedPlaces?.length > 0) {
      retrievedPlaces = retrievedPlaces.map((place: retrievedPlacesType) => ({
        key: place.place_id,
        value: place.place_id,
        title: place.description
      }));
    } else {
      retrievedPlaces = [];
    }
    return retrievedPlaces;
  } catch (error) {
    //eslint-disable-next-line
    console.log(error);
  }
};
